// Enum for weight units
export const WeightUnit = Object.freeze({
  Unknown: 'Unknown',
  Ounces: 'Ounces',
  Grams: 'Grams',
  Kilograms: 'Kilograms',
  Ounce: 'Ounce',
  Gram: 'Gram',
  Kilogram: 'Kilogram',
  Pounds: 'Pounds',
  Pound: 'Pound',
});

export const WeightUnitValues = Object.values(WeightUnit);
